export default "__VITE_ASSET__99187253__"